import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { openKinkyDare } from "./openKinkyDareAPI";

const initialState = {
    status: "idle",
    NewQuestion:'',
    NewQuestionTimer: '',
    DrinkQuestion: '',
    Attributes: [],
    Accessories:[],
    UsedQuestionsId:[],
    LastCard: false,
}

export const openKinkyDareAsync = createAsyncThunk(
    "/openkinkydare",
    async ({gender, player}, {getState, rejectWithValue}) => {
        try {
            const state = getState()
            const usedid = state.openKinkyDare.UsedQuestionsId
            const selectedaccessories = state.openKinkyDare.Accessories
            const sessionid = state.gameStatus.sessions['open'].sessionId

            const response = await openKinkyDare(gender, player, usedid, selectedaccessories, sessionid);
            return response
        } catch (error) {
            console.error("Error in openKinkyDareAsync:", error); // 👀 This should appear now
            return rejectWithValue(error.response
                ? { data: error.response.data, status: error.response.status }
                : { data: { error: "Unknown error" }, status: 500 })
        }
    }
)

export const openKinkyDareSlice = createSlice({
    name: "openkinkydare",
    initialState,
    reducers: {
        setAccessories: (state, action) =>{
            state.Accessories = action.payload
        },
        resetState:(state) =>{
            state.status ="idle"
            state.NewQuestion = ''
            state.NewQuestionTimer = ''
            state.DrinkQuestion = ''
            state.Attributes = []
            state.Accessories = []
            state.UsedQuestionsId =[]
            state.LastCard = false;
        },
    },
    extraReducers:(builder) => {
        builder
            .addCase(openKinkyDareAsync.pending, (state) => {
                state.status = 'fetching';
            })
            .addCase(openKinkyDareAsync.fulfilled, (state, action)=>{
                state.status ="fulfilled";
                state.NewQuestion = action.payload.question
                state.NewQuestionTimer = action.payload.timer
                state.DrinkQuestion = action.payload.drink
                state.UsedQuestionsId = [...state.UsedQuestionsId,action.payload.id]
                state.Attributes = [action.payload.attributes]
                state.LastCard = action.payload.last_card || false;
            })}})

export const selectOpenKinkyDare = (state) => state.openKinkyDare
export const { setAccessories, resetState} = openKinkyDareSlice.actions;
export default openKinkyDareSlice.reducer